import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { languages, getLocale } from "../../../../../common/parameters";

import routing from "../../../../routing";
import Icon from "../../../../icon";
import { profilePictureHost } from "../../../../paths";
import { StaffLines } from "../../../../components/Nav/StaffLines";

import {
    StyledNavRight,
    SmallIcon,
    MenuItem,
    StyledLogin,
    Moderation,
    Caret,
    StyledStaffLinesRight,
    StaffLinesRightStart,
    UserImage,
    Usermenu,
    UserName,
    Account,
    Logout,
    ChangeLanguage,
    User,
    MobileMenuOpener,
    LanguageDropdown,
    LanguageOption,
} from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

class NavRight extends Component<IProps> {
    state = { userMenuOpen: false, languageMenuOpen: false };
    toggleUsermenu = () => {
        if (!this.state.userMenuOpen) {
            setTimeout(() => {
                window.addEventListener("click", this.clickOutsideUsermenu);
            });
        } else {
            window.removeEventListener("click", this.clickOutsideUsermenu);
        }
        this.setState({ userMenuOpen: !this.state.userMenuOpen });
    };
    componentWillUnmount() {
        window.removeEventListener("click", this.clickOutsideUsermenu);
        window.removeEventListener("click", this.clickOutsideLanguageMenu);
    }
    clickOutsideUsermenu = () => {
        this.setState({ userMenuOpen: false });
        window.removeEventListener("click", this.clickOutsideUsermenu);
    };
    clickOutsideLanguageMenu = () => {
        this.setState({ languageMenuOpen: false });
        window.removeEventListener("click", this.clickOutsideLanguageMenu);
    };
    toggleLanguageMenu = () => {
        if (!this.state.languageMenuOpen) {
            setTimeout(() => {
                window.addEventListener("click", this.clickOutsideLanguageMenu);
            });
        } else {
            window.removeEventListener("click", this.clickOutsideLanguageMenu);
        }
        this.setState({ languageMenuOpen: !this.state.languageMenuOpen });
    };
    render() {
        const {
            loggedIn,
            admin,
            intl,
            intl: { formatMessage },
            user,
            mobileMenuOpen,
            handleOpenMobileMenu,
            logout,
            changeLanguage,
            profiled,
            isModeration,
            isAccount,
            isSignup,
            isLogin,
        } = this.props;
        const { userMenuOpen, languageMenuOpen } = this.state;
        return (
            <StyledNavRight>
                {!loggedIn && (
                    <>
                        <MenuItem $isActive={isSignup} to={"/" + routing.choir + "/" + routing.signup}>
                            <Icon i="signup" />
                            <FormattedMessage {...messages.registration} />
                        </MenuItem>
                        <MenuItem $isActive={isLogin} to={"/" + routing.choir + "/" + routing.login}>
                            <Icon i="login" />
                            <FormattedMessage {...messages.login} />
                        </MenuItem>
                        {/* <MenuItem active={isPathHelp} to={"/" + routing.help}>
                            <Icon i="help" />Segítség
                        </MenuItem> */}
                        <ChangeLanguage onClick={this.toggleLanguageMenu}>
                            {getLocale(intl.locale).toUpperCase()}
                            <Caret>
                                <svg width="11" height="9">
                                    <polygon points="0,0 11,0 5.5,5.5" />
                                </svg>
                            </Caret>
                            {languageMenuOpen && (
                                <LanguageDropdown>
                                    {languages(formatMessage, true).map(({ value, label }) => (
                                        <LanguageOption
                                            isActive={intl.locale === value}
                                            onClick={() => changeLanguage(value)}
                                        >
                                            {label}
                                        </LanguageOption>
                                    ))}
                                </LanguageDropdown>
                            )}
                        </ChangeLanguage>
                    </>
                )}

                {loggedIn && (
                    <>
                        {admin && (
                            <Moderation
                                $isActive={isModeration}
                                to={"/" + routing.choir + "/" + routing.moderation + "/users"}
                            >
                                <Icon i="admin" />
                                <FormattedMessage {...messages.moderation} />
                            </Moderation>
                        )}

                        <User onClick={this.toggleUsermenu}>
                            <UserImage>
                                {user.profilePicture ? (
                                    user.profilePicture.length === 16 ? (
                                        <img src={profilePictureHost + user.profilePicture + ".jpg"} alt="profile" />
                                    ) : (
                                        <img src={user.profilePicture} alt="profile" />
                                    )
                                ) : (
                                    <Icon i="user" />
                                )}
                            </UserImage>
                            <UserName>
                                {!user.displayName || user.displayName === "username"
                                    ? user.username || <FormattedMessage {...messages.username} />
                                    : user.first_name}
                            </UserName>
                            <Caret>
                                <svg width="11" height="6">
                                    <polygon points="0,0 11,0 5.5,5.5" />
                                </svg>
                            </Caret>
                            {userMenuOpen && (
                                <Usermenu>
                                    {profiled && (
                                        <Account $isActive={isAccount} to={"/" + routing.choir + "/" + routing.account}>
                                            <SmallIcon>
                                                <Icon i="account" />
                                            </SmallIcon>
                                            <FormattedMessage {...messages.account} />
                                        </Account>
                                    )}
                                    <Logout onClick={logout}>
                                        <SmallIcon>
                                            <Icon i="logout" />
                                        </SmallIcon>
                                        <FormattedMessage {...messages.logout} />
                                    </Logout>
                                </Usermenu>
                            )}
                        </User>
                    </>
                )}

                <MobileMenuOpener onClick={handleOpenMobileMenu}>
                    <div className={cn(mobileMenuOpen && "Active")}>
                        <div className={cn("Line", "Line1")}></div>
                        <div className={cn("Line", "Line2")}></div>
                        <div className={cn("Line", "Line3")}></div>
                    </div>
                </MobileMenuOpener>
                <StyledStaffLinesRight>
                    <StaffLines />
                    <StaffLinesRightStart width="24" height="24" viewBox="0 0 24 24">
                        <rect x="0" y="0" width="3" height="25"></rect>
                        <rect x="5" y="0" width="1" height="25"></rect>
                        <circle cy="9.5" cx="9" r="1" width="2" height="2" />
                        <circle cy="15.5" cx="9" r="1" width="2" height="2" />
                    </StaffLinesRightStart>
                </StyledStaffLinesRight>
            </StyledNavRight>
        );
    }
}

export default NavRight;
